export enum StateStorageLocation {
    Internal,
    Session,
    Persistent,
}
